import { Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  FairwayStateEnum,
  FairwayTypeEnum,
  LightingEnum,
  SeaAreaEnum,
} from "~/api/GeneratedApi";
import { FairwayMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  map: Map;
} & (ClickProps | HoverProps);

type ClickProps = {
  clickData: FairwayMapItem;
  hoverData?: FairwayMapItem;
};

type HoverProps = {
  hoverData: FairwayMapItem;
  clickData?: FairwayMapItem;
};

export const FairwayPopup = ({
  hoverData,
  clickData,
  map,
}: Props): JSX.Element | null => {
  const { t } = useTranslation("fairway");

  const data = clickData ?? hoverData;

  if (!data) return null;

  const {
    name,
    fairwayId,
    nameFin,
    fairwayState,
    fairwayType,
    lighting,
    draught1,
    draught2,
    draught3,
    seaArea,
    startDescription,
    endDescription,
    fairwayClass,
  } = data;

  return (
    <GenericPopup
      map={map}
      clicked={!!clickData}
      avatarText={fairwayId?.toString() ?? ""}
      title={`${t("fairway")} - ${name ?? ""}`}
      subheader={nameFin ?? ""}
      content={
        <>
          <Typography variant="body2" align="left" noWrap>
            {`${t("state")}: ${t(
              `fairway-state:${FairwayStateEnum[fairwayState]}`,
            )}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("type")}: ${
              fairwayType
                ? t(`fairway-type:${FairwayTypeEnum[fairwayType]}`)
                : "-"
            }`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("lighting")}: ${t(
              `fairway-lighting:${LightingEnum[lighting]}`,
            )}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("draught")}1: ${draught1 ?? "-"}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("draught")}2: ${draught2 ?? "-"}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("draught")}3: ${draught3 ?? "-"}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("sea-area")}: ${t(
              `fairway-sea-area:${SeaAreaEnum[seaArea]}`,
            )}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("start-description")}: ${startDescription ?? "-"}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("end-description")}: ${endDescription ?? "-"}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("class")}: ${fairwayClass ?? "-"}`}
          </Typography>
        </>
      }
    />
  );
};
